import { render, staticRenderFns } from "./ChangeGroupSlidebar.vue?vue&type=template&id=f800afec"
import script from "./ChangeGroupSlidebar.vue?vue&type=script&lang=js"
export * from "./ChangeGroupSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports